import { IApplicationState } from '../../types/redux';

export function selectMortgageRates(state: IApplicationState) {
  return state.mortgage.analyticsData.rates;
}
